import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {Tracking, TrackingEvent} from '@common/tracking'
import BoardSettingsIcon from '@components/board/board-settings/board-settings-icon'
import {boardSettingsStore} from '@components/board/board-settings/board-settings-store'
import {LinkButtonNew} from '@components/common/base/buttons'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {
  TwStickerHeader,
  TwStickerHeaderTitle
} from '@components/sticker/sticker-menu/containers'
import {useStickerStore} from '@components/sticker/sticker-store'
import {useBoard} from '@containers/hooks'

interface StickerHeaderT {
  title: string
  stickerId: string
  showSettings?: boolean
  onClickOnSettingHandler?: () => void
  showUnpin?: boolean
  children?: React.ReactNode
  className?: string
}

export const StickerMenuHeader = observer(
  ({
    title,
    stickerId,
    showSettings = true,
    onClickOnSettingHandler,
    showUnpin = true,
    children,
    className
  }: StickerHeaderT): JSX.Element => {
    const [, store] = useStickerStore()
    const board = useBoard()
    const allowEdit = PermissionsChecker.checkEditBoardStickers(board)
    const {isAddingTask} = store.stickerData
    const {required} = store.state

    const onClickOnSetting = () => {
      boardSettingsStore.setCurrentTabId('stickers')
      boardSettingsStore.addIntoAdditionalTabInfo({
        stickerIdToEdit: stickerId as DataObjectId
      })
      boardSettingsStore.toggle()
      void Tracking.send(
        TrackingEvent.boardSettingsOpenStickersListViaStickerMenu
      )
      if (store.toggleStickerMenu) {
        store.toggleStickerMenu()
      }
      if (onClickOnSettingHandler) {
        onClickOnSettingHandler()
      }
    }

    return (
      <TwStickerHeader className={className}>
        <Tooltip content={title} placement="top">
          <TwStickerHeaderTitle data-test="sticker-header-title">
            {Lang.msg.sticker}&nbsp;«{title}»
          </TwStickerHeaderTitle>
        </Tooltip>
        {store.stickerData.location === 'panel' &&
          allowEdit &&
          showSettings && (
            <div className={`${!children ? 'ml-auto' : 'ml-8'} flex`}>
              <BoardSettingsIcon onClick={onClickOnSetting} />
            </div>
          )}
        {store.stickerData.location === 'task' &&
          !(isAddingTask && required) &&
          showUnpin && (
            <div className="ml-auto">
              <LinkButtonNew onClick={store.unpinSticker}>
                {Lang.msg.unpin}
              </LinkButtonNew>
            </div>
          )}
        {!!children && children}
      </TwStickerHeader>
    )
  }
)
